<!-- 设置 -->
<template>
  <div class="main-content">
    <div style="margin: 10px;">
      <el-button no="onSave" type="success" @click="onSave">{{ $t('Pricing.Save') }}</el-button>
      <el-button no="onCancel" type="success" @click="onCancel">{{ $t('Pricing.Cancel') }}</el-button>
    </div>
    <div class="section" style="padding: 12px;">
      <div style="display: flex; width: 100%">
        <div class="form-column">
          <el-form
            ref="kpi"
            label-width="130px"
            label-position="right"
            :model="kpi"
          >
            <el-form-item :label="$t('Pricing.StartTime')">
              <div style="display: flex">
                <el-input-number
                  v-model="kpi.starttime"
                  no="starttime"
                  :max="23"
                  :min="0"
                  style="width: 100%"
                />
                <label style="margin-left: 10px">{{ $t('Pricing.Hour') }}</label>
              </div>
            </el-form-item>
            <el-form-item :label="$t('Pricing.EndTime')">
              <div style="display: flex">
                <el-input-number
                  v-model="kpi.endtime"
                  no="endtime"
                  :max="23"
                  :min="0"
                  style="width: 100%"
                />
                <label style="margin-left: 10px">{{ $t('Pricing.Hour') }}</label>
              </div>
            </el-form-item>
            <el-form-item :label="$t('Pricing.CheckInterval')">
              <div style="display: flex">
                <el-input-number
                  v-model="kpi.interval"
                  no="interval"
                  :max="23"
                  :min="1"
                  style="width: 100%"
                />
                <label style="margin-left: 10px">{{ $t('Pricing.Hour') }}</label>
              </div>
            </el-form-item>
            <el-form-item :label="$t('Pricing.MaxMailPerDay')">
              <div style="display: flex">
                <el-input-number
                  v-model="kpi.maxperday"
                  no="maxperday"
                  style="width: 100%"
                  :max="23"
                  :min="1"
                />
                <label style="margin-left: 10px">{{ $t('Pricing.Times') }}</label>
              </div>
            </el-form-item>
            <el-form-item
              :label="$t('Pricing.KPIEmail')"
              prop="email"
              :rules="[
                { required: true, message: $t('Price.TheEmailCannotBeEmpty')},
                { type: 'email', message: $t('Price.EmailFormatError')}
              ]"
            >
              <el-input
                v-model="kpi.email"
                no="email"
                style="width: 100%"
              />
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import FclDataGrid from '@/views/cargo/v0/Price/components/grid/fclDataGrid'
import MarkupFclDataGrid from '@/views/cargo/v0/Price/PriceFCL/components/PriceFCL/markupFclDataGrid'
import { saveOrUpdateConfig, searchConfig } from '@/api/user'
import $store from '@/store'
import StrUtil from '@/utils/StrUtils'
import { getLoading } from '@/utils/utilBaseElement'
export default {
  name: 'TabKPISettings',
  components: { MarkupFclDataGrid, FclDataGrid },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    priceName: {
      type: String,
      default: () => 'PF'
    }
  },
  data() {
    return {
      kpi: {
        starttime: 0,
        endtime: 0,
        interval: 0,
        maxperday: 0,
        email: ''
      },
      cfg: null,
      cfgDef: null,
      fullscreenLoading: false
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close', val)
        } else {
          this.$emit('open', val)
        }
      }
    },
    configName() {
      return this.priceName + 'CheckApproveSetting'
    }
  },
  watch: {},
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.loadSettings()
    },
    loadSettings() {
      searchConfig({ officeId: $store.getters.currentOfficeId, configName: this.configName }).then((res) => {
        this._isMarkupSettingsLoaded = true
        const results = res.data
        for (const item of results) {
          if (item.hasOwnProperty('overrideable')) { // Config 才有这个字段
            this.cfg = item
          } else {
            this.cfgDef = item
          }
        }
        this.onSettingsLoaded()
      })
    },
    onSettingsLoaded() {
      const map = {}
      if (this.cfg && this.cfg.value) {
        const setting = this.cfg.value
        const settings = setting.split(';')
        let pair = []
        for (const pairs of settings) {
          pair = pairs.split(':')
          map[(pair[0]).toLowerCase()] = pair[1]
        }
      }
      this.kpi.starttime = Number(map['starttime']) || 9
      this.kpi.endtime = Number(map['endtime']) || 18
      this.kpi.interval = Number(map['interval']) || 3
      this.kpi.maxperday = Number(map['maxperday']) || 2
      if (map['email']) {
        this.kpi.email = map['email']
      } else {
        const currentUser = this.$store.getters.userInfo
        this.kpi.email = currentUser.email || ''
      }
    },
    onSave() {
      this.$refs.kpi.validate((valid) => {
        if (!valid) {
          return
        }
        const { starttime, endtime, interval, maxperday, email } = this.kpi
        if (starttime >= endtime) {
          this.$message.warning(this.$t('Pricing.CompareTime'))
          return
        }
        const setting = StrUtil.substitute('startTime:{0};endTime:{1};interval:{2};maxPerDay:{3};email:{4}', starttime, endtime, interval, maxperday, email)
        if (this.cfg === null) {
          this.cfg = {}
          this.cfg.configId = this.cfgDef.configId
          this.cfg.officeId = 1
          this.cfg.isOverrideable = false
        }
        this.cfg.value = setting
        this.fullscreenLoading = getLoading()
        saveOrUpdateConfig(this.cfg).then((res) => {
          this.cfg = res.data
          this.$message.success(this.$t('Pricing.SavedSucceed'))
          this.onCancel()
        }).finally(() => {
          this.fullscreenLoading.close()
        })
      })
    },
    onCancel() {
      this.$emit('close')
    }
  }
}
</script>

<style  lang="scss" scoped>
</style>
